import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  OnInit,
  signal,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import {
  AutoDropdownComponent,
  getExtraBurgerMenuOptions,
  listRow,
  ListViewV2Component,
  MenuOption,
  AutoMultiselectComponent,
} from '@standard-angular-utilities/shared-components';
import { User, LogDTO, LogType } from 'BaseDataTypes';
import { UserService } from 'BaseServices/user-service';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
@Component({
  selector: 'app-base-list-page',
  imports: [
    AutoDropdownComponent,
    ListViewV2Component,
    MatButtonModule,
    MatIconModule,
    AutoMultiselectComponent,
    MatCheckboxModule,
    FormsModule,
  ],
  templateUrl: './base-list-page.component.html',
  styleUrl: './base-list-page.component.css',
})
export class BaseListPageComponent<rowType extends object> implements OnInit {
  @Input() filterLists: FilterList[] = [];
  @Input() confirmSelected?: (data: listRow<rowType>[]) => void;
  @Input() createNew: (() => void) | null = null;
  @Input() headersList: string[] = [];
  @Input() logHeaderList: string[] = [];
  @Input() extraBurgerMenuOptions: MenuOption[] = [];
  @Input() switchDataToggle: (isHistory: boolean) => void = () => {};
  @Input() multiSelectFilterLists: multiSelectFilterList[] = [];
  @Input() newItemLabel: string = 'Opret ny';
  @Input() checkboxes: checkbox[] = [];
  isHistory: boolean = false;
  multieditMode: boolean = false;
  @ViewChild('listView') listView: ListViewV2Component<rowType> | undefined;
  @ViewChild('logListView') logListView:
    | ListViewV2Component<LogDTO>
    | undefined;

  @Output() rowClick = new EventEmitter<rowType>();

  compiledFunctionSignal = signal<(item: rowType) => boolean>(() => true);
  listDataSignal = signal<listRow<rowType>[]>([]);
  logListDataSignal = signal<listRow<LogDTO>[]>([]);

  UpdateListData(data: listRow<rowType>[]) {
    this.listDataSignal.set(data);
  }
  UpdateLogListData(data: listRow<LogDTO>[]) {
    this.logListDataSignal.set(data);
  }

  onRowClick(row: rowType) {
    this.rowClick.emit(row);
  }
  constructor(public userService: UserService) {}
  ngOnInit(): void {
    if (this.logHeaderList.length > 0) {
      this.getLogToggleButton();
    }
  }
  getLogToggleButton() {
    const isAdmin =
      this.userService.getSelectedRole ===
      this.userService.getUserRoleTypes.Admin;
    this.extraBurgerMenuOptions = getExtraBurgerMenuOptions(
      isAdmin,
      this.isHistory,
      'Skift til data visning',
      () => {
        this.switchDataToggle(this.isHistory);
        this.isHistory = !this.isHistory;
      },
      () => this.extraBurgerMenuOptions[0][0],
      (newLabel: string) => {
        this.extraBurgerMenuOptions[0][0] = newLabel;
      },
    );
  }
  get selectedCount(): number {
    if (!this.listView) return 0;
    return this.listView.getCheckedRows().length;
  }
  setDefaultHeaders(hiddenHeaders: string[]) {
    if (!this.listView) return;
    if (localStorage.getItem(this.listView.id() + '_headerList')) return;
    const visibility = this.listView
      .headerList()
      .map((header) => !hiddenHeaders.includes(header));
  }
  checkForRender(index: number | undefined) {
    return (
      index === undefined ||
      (this.listView && this.listView.showItemList[index])
    );
  }

  checkAndRunOnChange = () => {
    this.compiledFunctionSignal.set(
      (item: rowType) =>
        (!this.filterLists && !this.multiSelectFilterLists) ||
        (this.filterLists.every((f) => f.filterFunction(item)) &&
          this.multiSelectFilterLists.every((m) => m.filterFunction(item))),
    );
  };
}

export interface FilterList {
  selectedValue: number;
  items: any[];
  displayProperty: string;
  label: string;
  HideWithHeaderIndex?: number | undefined;
  filterFunction: (item: any) => boolean;
}

export interface multiSelectFilterList {
  Items: any[];
  selectedItemsIds: number[] | any[];
  placeHolderText: string;
  selectedValueChange(changeTarget: any): void;
  HideWithHeaderIndex?: number | undefined;
  filterFunction: (item: any) => boolean;
}

export interface checkbox {
  onchanged: (checked: boolean) => void;
  binding: boolean;
  text: string;
}
